import GeneralServices from "./GeneralServices";

class WebEdaServices {

  getWPSignStatus = async (setLoading: any, loader: any, args: any) => {
    try {
      const response = await GeneralServices.get({
        setLoading: setLoading,
        loader: loader === false ? false : true,
        endpoint: `webeda/GetWPSignStatus?NifTomador=${args.NifTomador}&NumPoliza=${args.NumPoliza}`,
      });
      return response.data;
    }
    catch (err) {
      return {};
    }
  }
  getWPStatus = async (setLoading: any, loader: any, args: any) => {
    let params = ''
    Object.keys(args).forEach(arg => {
      params = params === ''
        ? '?' + arg + '=' + args[arg]
        : params + '&' + arg + '=' + args[arg]
    })
    try {
      const response = await GeneralServices.get({
        setLoading: setLoading,
        loader: loader === false ? false : true,
        endpoint: `webeda/GetWPStatus${params}`,
      });
      return response.data;
    }
    catch (err) {
      return null;
    }
  }
  getConsultaTarjetas = async (setLoading: any, loader: any, args: any) => {
    try {
      const response = await GeneralServices.get({
        setLoading: setLoading,
        loader: loader === false ? false : true,
        endpoint: `webeda/GetConsultarTarjeta?NifAsegurado=${args.NifAsegurado}&NumPoliza=${args.NumPoliza}`,
      });
      console.log(response)
      return response.data;
    }
    catch (err) {
      return {};
    }
  }

}

export default new WebEdaServices();